import React from 'react';

import {observer} from 'mobx-react';
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {StandingsDestinationViewModel} from "../../../../domain/standings/models/destinations/standings.destinations.view-model";
import {StandingsWidgetController} from "../../standings-widget.controller";
import classNames from "classnames";
import styles from "../../styles/standings-widget.module.scss";
import {Ellipsis} from "../../../../core/components/misc/ellipsis/ellipsis";

export class StandingsWidgetCompetitorWinnerDescriptionProps extends BaseProps {
  controller: StandingsWidgetController;
  row: StandingsDestinationViewModel;
}

export const StandingsWidgetCompetitorWinnerDescription = observer(({controller, row}: StandingsWidgetCompetitorWinnerDescriptionProps) => {
  const {state} = controller;
  const {winnerDescription} = state;
  const {destination, isWinner} = row;

  const winnerDescriptionProps = {
    text: winnerDescription,
    numOfMaxLines: 2,
    className: classNames(styles.competitor_destination),
    style: {
      color: destination?.color
    },
  }

  return isWinner ? <Ellipsis {...winnerDescriptionProps}/> : null
});
